import { baseStrapiURL } from '../config';

/**
 * Service pour vérifier l'accès utilisateur à une formation
 */
export const checkAccessService = {
    /**
     * Vérifier si un email a déjà accès à une formation
     * @param {string} email - Email de l'utilisateur
     * @param {string} trainingId - ID ou slug de la formation
     * @returns {Promise<Object>} Résultat de la vérification
     */
    async checkUserAccess(email, trainingId) {
        try {
            console.log('🔍 Vérification accès utilisateur:', { email, trainingId });

            const response = await fetch(`${baseStrapiURL}/api/check-user-access`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email.toLowerCase().trim(),
                    trainingId
                })
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error?.message || 'Erreur lors de la vérification');
            }

            const data = await response.json();
            console.log('✅ Résultat vérification:', data);

            return {
                success: true,
                ...data
            };

        } catch (error) {
            console.error('❌ Erreur vérification accès:', error);
            
            return {
                success: false,
                error: error.message,
                hasAccess: false,
                userExists: false
            };
        }
    }
};